var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.375V9.375C3.5 9.86719 3.88281 10.25 4.375 10.25H8.75V8.0625C8.75 7.35156 9.32422 6.75 10.0625 6.75H12.25V2.375C12.25 1.91016 11.8398 1.5 11.375 1.5H4.375C3.88281 1.5 3.5 1.91016 3.5 2.375ZM12.1953 7.625H10.0625C9.81641 7.625 9.625 7.84375 9.625 8.0625V10.2227C9.73438 10.168 9.84375 10.0859 9.95312 10.0039L11.9766 7.98047C12.0859 7.87109 12.1406 7.76172 12.1953 7.625ZM2.625 2.375C2.625 1.41797 3.39062 0.625 4.375 0.625H11.375C12.332 0.625 13.125 1.41797 13.125 2.375V7.35156C13.125 7.81641 12.9336 8.25391 12.6055 8.58203L10.5547 10.6328C10.2266 10.9609 9.78906 11.125 9.32422 11.125H4.375C3.39062 11.125 2.625 10.3594 2.625 9.375V2.375ZM8.75 13.3125C8.75 13.5586 8.53125 13.75 8.3125 13.75H3.5C1.55859 13.75 0 12.1914 0 10.25V3.6875C0 3.46875 0.191406 3.25 0.4375 3.25C0.65625 3.25 0.875 3.46875 0.875 3.6875V10.25C0.875 11.6992 2.05078 12.875 3.5 12.875H8.3125C8.53125 12.875 8.75 13.0938 8.75 13.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.8026db637d6afb2ba0206c7257079167.svg";
export { ForwardRef as ReactComponent };